export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-compass-37a56cc54459e2493f725822935ac105.svg";